export const findSelected = (options, selectedValue, idKey = 'id') => options.find(o => o[idKey] === selectedValue);
